import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuSessionService } from './services/menu-session.service';
import keycloak from './keycloak-init';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private readonly menuSession = inject(MenuSessionService);

  ngOnInit(): void {
    if (keycloak.authenticated && this.isAdminSession()) {
      void this.menuSession.syncMenuFromSession();
    }
  }

  /** Misma regla que RoleRedirectGuard: solo el panel administrativo usa el menú. */
  private isAdminSession(): boolean {
    const roles = keycloak.tokenParsed?.resource_access?.['sc-ms-mb-gateway']?.roles ?? [];
    return roles.some((role) => role === 'admin');
  }
}
